/* eslint-disable max-len */
import EDC from '../../../shared/globals';

EDC.Animations.Airplane = function (scene, gameConfig) {
  this.scene = scene;
  this.gameConfig = gameConfig;
  this.airplane = null;
  this.figureName = null;
  this.banner = null;
  this.shapeSprite = null;
  this.isCorrectAnimationRunning = false;
  this.container = null;
};

EDC.Animations.Airplane.prototype.create = function () {
  this.container = this.scene.add.container(this.scene.game.config.width, 60);
  this.airplane = this.scene.add.sprite(0, 0, 'airplane').setOrigin(0);
  this.airplane.play('propeller');
  this.container.add(this.airplane);

  this.banner = this.scene.add.sprite(400, 35, 'banner').setOrigin(0);
  this.container.add(this.banner);

  this.figureName = this.scene.add
    .text(0, 0, 'PARALLELOGRAM', {
      fontFamily: 'Arial',
      fontSize: '55px',
      color: 'black',
    })
    .setOrigin(0.5);
  this.figureName.setPosition(this.banner.x + 370, this.banner.y + this.banner.height / 2);
  this.container.add(this.figureName);

  this.container.setSize(this.airplane.width, this.airplane.height);
  this.scene.tweens.add({
    targets: this.container,
    y: this.container.y + 100,
    duration: 1400,
    ease: 'Sine.easeInOut',
    yoyo: true,
    repeat: -1,
  });
};

EDC.Animations.Airplane.prototype.flyAway = function () {
  const targetX = this.airplane.width + this.banner.width + (this.shapeSprite ? this.shapeSprite.width : 0);
  this.scene.tweens.add({
    targets: this.container,
    x: -targetX,
    duration: 2300,
    ease: 'Linear',
    onComplete: () => {
      this.scene.nextIteration();
    },
  });
};

EDC.Animations.Airplane.prototype.arrive = function () {
  this.isCorrectAnimationRunning = false;
  this.container.x = this.scene.game.config.width;
  this.scene.tweens.add({
    targets: this.container,
    x: 380,
    duration: 2300,
    ease: 'Linear',
  });
};

EDC.Animations.Airplane.prototype.setFigure = function (name) {
  this.figureName.setText(name);
};

EDC.Animations.Airplane.prototype.addFigureSprite = function (shapeSprite) {
  this.isCorrectAnimationRunning = true;
  this.shapeSprite = shapeSprite;
  this.scene.tweens.add({
    targets: this.shapeSprite,
    alpha: 0,
    duration: 500,
    ease: 'Linear',
    onComplete: this.teleportShape.bind(this),
  });
};

EDC.Animations.Airplane.prototype.flashIn = function () {
  this.scene.tweens.add({
    targets: this.shapeSprite,
    alpha: 0,
    duration: 500,
    ease: 'Linear',
    repeat: 1,
    yoyo: true,
    onComplete: this.flyAway.bind(this),
  });
};

EDC.Animations.Airplane.prototype.teleportShape = function () {
  this.shapeSprite.setPosition(this.banner.x + this.banner.width, this.banner.y + this.banner.height / 2);
  this.container.add(this.shapeSprite);
  this.scene.tweens.add({
    targets: this.shapeSprite,
    alpha: 1,
    duration: 500,
    ease: 'Linear',
    onComplete: this.flyAway.bind(this),
  });
};

EDC.Animations.Airplane.prototype.flashOut = function () {
  this.scene.tweens.add({
    targets: this.shapeSprite,
    alpha: 1,
    duration: 500,
    ease: 'Linear',
    repeat: 1,
    yoyo: true,
    onComplete: this.teleportShape.bind(this),
  });
};

export default EDC.Animations.Airplane;
